import { createCustomBlock, t, mergeBlock } from "easy-email-pro-core";
import React from "react";
import { ElementCategory } from "easy-email-pro-core";

export const CustomReportBlockType = {
  LOGO: "Reports",
};

const defaultData = {
  data: {
    reportData: []
  },
  attributes: {
    "padding-top": "20px",
    "padding-bottom": "20px",
    "padding-right": "40px",
    "padding-left": "40px",
    "background-color": "#ffffff",
    "color": "#4a90e2",
    "font-size": "13px",
  }
};

export const CustomReportBlock = createCustomBlock({
  get name() {
    return t("Reports");
  },
  defaultData: defaultData,
  type: CustomReportBlockType.LOGO,
  void: true,
  create: (payload) => {
    const data = {
      type: CustomReportBlockType.LOGO,
      data: {
        ...defaultData.data,
      },
      attributes: {
        ...defaultData.attributes,
      },
      children: [],
    };
    return mergeBlock(data, payload);
  },
  category: ElementCategory.TEXT_LIST,
  render(params) {
    const { node } = params;
    const { data, attributes } = node;

    return (
      <mj-section
        padding="0"
      >
        <mj-section padding-bottom={attributes["padding-bottom"]} background-color={attributes["background-color"]}
          padding-top={attributes["padding-top"]}
          padding-left={attributes["padding-left"]}
          padding-right={attributes["padding-right"]}>
          {data.reportData.filter(curElem => curElem.isCheck).map((val, index) => {
            return (
              <mj-section key={index} padding="0" padding-bottom="10px" background-color={attributes["background-color"]}
              >
                <mj-group>
                  <mj-column width="5%">
                    <mj-image
                      height="20px"
                      width="20px"
                      src={val.icon}
                      padding="0"
                      alt={val.name}
                    />
                  </mj-column>
                  <mj-column width="95%">
                    <mj-text
                      color={attributes.color}
                      padding="0px 0 0 10px"
                      css-class="text-block"
                    >
                      <a
                        href={val.file}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          textDecoration: "none", color: attributes.color, fontSize: attributes["font-size"], lineHeight: "16px",
                          fontFamily: attributes["font-family"] || "Arial, sans-serif"
                        }}
                      >
                        {val.name}
                      </a>
                    </mj-text>
                  </mj-column>
                </mj-group>
              </mj-section>
            )
          })}
        </mj-section>
      </mj-section>
    );
  },
});